<script>
	import Star from '../../../assets/star.svelte';
	import ProfilePicture from './ProfilePicture.svelte';

	export let position = 1;
	export let user = {};
	export let text = '';
	export let userId = '';
	export let shared = false;
	export let notFloating = true;
	let highlight = false;
	let backgroundColor = [
		'rgba(250, 209, 85, 1)',
		'rgba(196, 196, 196, 1)',
		'rgba(228, 194, 162, 1)',
		'rgba(244, 244, 244, 1)'
	];
	const getScoreColor = (position) => {
		if (position === 1) {
			return 'green';
		} else if (position <= 3) return 'rgba(242, 153, 74, 1)';
		else return 'rgba(196, 196, 196, 1)';
	};
	$: {
		if (position > 3) {
			highlight = userId == user.id;
		}
	}
</script>

{#if user}
	<div
		class="singleUserWrapper"
		class:highlight
		class:notFloating
		style={`background-color:${backgroundColor[Math.min(3, position - 1)]}`}
	>
		<div class="positionWrapper">
			<div class="starWrapper">
				{#if position <= 3}
					<Star />
				{:else}
					<ProfilePicture whiteCircle={true} text={`${position}`} size="28" />
				{/if}
				<span class="positionSpan">{position}</span>
			</div>
		</div>

		<div class="profilePicture">
			<ProfilePicture
				src={user.src}
				userName={user.name}
				size="28"
				fontSize="14"
				whiteCircle={shared}
				{text}
			/>
		</div>

		<div class="userName" class:shared>
			<p>{user.name}</p>
		</div>
		<div class="score" style={`background-color:${getScoreColor(position)}`}>{user.score}</div>
	</div>
{/if}

<style>
	.singleUserWrapper {
		height: 40px;
		width: 100%;
		position: relative;
		display: flex;
		align-items: center;
		border-radius: 6px;
		padding: 6px 10px;
	}
	.positionWrapper {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.starWrapper {
		position: relative;
		color: black;
		width: 27px;
		height: 28px;
	}
	.positionSpan {
		color: black;
		font-size: 12px;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.profilePicture {
		margin-left: 1.25rem;
		width: 28px;
		height: 28px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.score {
		margin-left: auto;
		margin-right: 0;
		height: 30px;
		min-width: 34px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 8px;
		color: white;
		font-family: 'Manrope';
		font-weight: 500;
		font-size: 14px;
	}

	.userName {
		margin-left: 8px;
		margin-right: 5px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 13px;
		font-family: 'Work Sans';
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
	}

	.highlight {
		background-color: rgba(108, 68, 168, 1) !important;
	}
	.highlight .userName {
		color: white !important;
	}
	.shared {
		font-weight: 700;
		color: rgba(51, 51, 51, 1);
	}
</style>
